import { memo } from 'react';
import { IconProps } from './iconType';

export const PlusIcon = memo(({ size, color }: IconProps) => {
  return (
    // export된 svg가 있다면 => 코드창에 열어서 있는 코드 아래 형식처럼 수정하기
    // 디자인 파일에서 svg가 있다면 => svg 코드 복사해서 아래 형식처럼 수정하기
    // xmlns 속성은 제거
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none">
      <rect x="13.25" y="5" width="1.5" height="18" fill={color} />
      <rect x="5" y="13.25" width="18" height="1.5" fill={color} />
    </svg>
  );
});

PlusIcon.displayName = 'PlusIcon';
